
export default item => ({
  slug: item.vehicleCode,
  vehicleId: item.vehicleId,
  transferId: item.transferId,
  name: `${item.name} (${item.group}, ${item.maximumPassengers})`,
  price: {
    ...item.price
  }
})